(() => {
  if (customElements.get('catalog-mobile-browser')) return;
  class CatalogMobileBrowser extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const data = JSON.parse(this.querySelector('[data-catalog-mobile-data]').textContent);
      this.nodes = new Map(data.nodes.filter(Boolean).map(node => [node.id, node]));
      this.roots = data.roots; this.stack = [];
      this.menu = this.closest('.mobile-menu');
      this.toggle = document.querySelector('.header__mobile-nav-toggle[aria-controls="mobile-menu"]');
      this.rows = this.querySelector('[data-catalog-rows]');
      this.back = this.querySelector('[data-catalog-back]');
      this.titleElement = this.querySelector('h2');
      this.scroller = this.querySelector('.catalog-mobile-menu__scroll');
      this.controller = new AbortController();
      this.addEventListener('click', event => {
        const forward = event.target.closest('[data-catalog-forward]');
        if (forward) { this.stack.push({id: forward.dataset.catalogForward, scroll: this.scroller.scrollTop}); this.render(); this.titleElement.focus({preventScroll: true}); }
        else if (event.target.closest('[data-catalog-back]')) this.goBack();
      }, {signal: this.controller.signal});
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); this.stack.length ? this.goBack() : this.close(); }
        if (event.key === 'Tab') {
          const items = [...this.querySelectorAll('button,a[href]')].filter(el => el.getClientRects().length);
          const first = items[0], last = items.at(-1);
          if (event.shiftKey && (document.activeElement === first || document.activeElement === this.titleElement)) { event.preventDefault(); last?.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
        }
      }, {signal: this.controller.signal});
      this.observer = new MutationObserver(() => {
        if (this.menu.getAttribute('aria-hidden') === 'false') { this.stack = []; this.render(); this.titleElement.focus({preventScroll: true}); }
      });
      this.observer.observe(this.menu, {attributes: true, attributeFilter: ['aria-hidden']});
      this.render();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; this.observer?.disconnect(); }
    visibleChildren(ids) { return ids.map(id => this.nodes.get(id)).filter(Boolean); }
    icon(path) { const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg'); svg.setAttribute('viewBox','0 0 24 24'); svg.setAttribute('aria-hidden','true'); const p = document.createElementNS(svg.namespaceURI,'path'); p.setAttribute('d',path); svg.append(p); return svg; }
    render() {
      const current = this.nodes.get(this.stack.at(-1)?.id);
      this.back.closest('.catalog-mobile-menu__toolbar').hidden = !current; this.back.hidden = !current; this.titleElement.textContent = current?.title || 'כל המחלקות';
      this.querySelector('[data-catalog-utilities]').hidden = !!current;
      this.rows.replaceChildren();
      for (const node of this.visibleChildren(current?.children || this.roots)) {
        const children = this.visibleChildren(node.children); const row = document.createElement(children.length ? 'button' : 'a');
        row.className = 'catalog-mobile-menu__row'; row.dataset.catalogNode = node.id;
        if (children.length) { row.type = 'button'; row.dataset.catalogForward = node.id; row.setAttribute('aria-label',`${node.title} — פתיחת תתי קטגוריות`); } else row.href = node.url;
        const picture = document.createElement('span'); picture.className = 'catalog-mobile-menu__image';
        const fallback = () => picture.replaceChildren(this.icon('M4 6h6l2 2h8v12H4z'));
        if (node.image) { const image = new Image(40,40); image.src = node.image; image.alt = ''; image.loading = 'lazy'; image.addEventListener('error',fallback,{once:true}); picture.append(image); } else fallback();
        const name = document.createElement('span'); name.className = 'catalog-mobile-menu__name'; name.textContent = node.title;
        row.append(picture,name); if (children.length) row.append(this.icon('m15 5-7 7 7 7'));
        const li = document.createElement('li'); li.append(row); this.rows.append(li);
      }
      this.scroller.scrollTop = 0;
    }
    goBack() { const old = this.stack.pop(); if (!old) return; this.render(); this.scroller.scrollTop = old.scroll; [...this.rows.querySelectorAll('[data-catalog-node]')].find(el => el.dataset.catalogNode === old.id)?.focus({preventScroll:true}); }
    close() { if (this.menu.getAttribute('aria-hidden') === 'false') this.toggle?.click(); this.toggle?.focus({preventScroll:true}); }
  }
  customElements.define('catalog-mobile-browser', CatalogMobileBrowser);
})();
